import {Entity} from "../domain/entities/entity";

/**
 * A command whose payload is not the entity it changes (an ADR-016 `CommandPayload`), but which still has to tell
 * the local side which entity that is — for `entity.changed` and `markAsPersisted()`. Feature plan 0074: the
 * Recolor commands. `BulkCommandHandler` and the commands' own handlers read the entity from here.
 */
export interface CarriesEntity<T extends Entity = Entity> {
    readonly entity: T;
}

/** The entity a command changes: its `entity` if it carries one, else its payload if that is an entity. */
export function entityOfCommand(command: {payload: unknown} & Partial<CarriesEntity>): Entity | null {
    if (command.entity instanceof Entity) {
        return command.entity;
    }
    return command.payload instanceof Entity ? command.payload : null;
}
